//PrimeReact
import { Dialog } from "primereact/dialog"

//Style
import styles from "../../../../../styles/referrals/ReferralEntityFormValidation.module.css"
import { Button } from "primereact/button"
import { Tooltip } from "primereact/tooltip"
import { Badge } from "primereact/badge"
import { ListBox } from "primereact/listbox"
import { useState } from "react"

export default function ReferralEntityFormValidationDialog({
  validationPartnerProfile,
  showDialog,
  onHideDialog,
  onSelectProfile,
}) {
  const [serviceDialogTitle, setServiceDialogTitle] = useState("")
  const [serviceDialogServices, setServiceDialogServices] = useState([])

  const PartnerLocation = ({ profile }) => {
    let refEntityStatus = "warning"

    if (profile.entityStatus === "confirmed") {
      refEntityStatus = "success"
    } else if (profile.entityStatus === "under review") {
      refEntityStatus = "info"
    }

    let cats = "<Uncategorized>"
    let catFontColorClass = styles.refEntityCategoryColor
    if (profile.referralCategories && profile.referralCategories.length > 0) {
      cats = profile.referralCategories.join("; ")

      if (cats.length > 100) {
        cats = `${cats.substr(0, 97)}...`
      }

      catFontColorClass = ""
    }

    return (
      <div
        className={`${styles.locationCard} ${
          validationPartnerProfile?.locations?.length > 1
            ? styles.locationCardBorder
            : ""
        }`}
      >
        <div className={styles.locationCardPartnerName}>
          {profile.entityName}
        </div>
        <div className={styles.locationCardLocationName}>{`${profile.name} ${
          !!profile.city ? `: (${profile.city})` : ""
        }`}</div>
        <div className={styles.locationCardLocationPhone}>{profile.phone}</div>
        <div
          className={`${styles.locationCardLocationServices} ${catFontColorClass}`}
        >
          {cats}
        </div>
        <div className={styles.locationCardLocationAttributes}>
          <Tooltip target=".badgeSpan" />
          <span
            className="badgeSpan material-icons"
            data-pr-tooltip={`This is a ${
              !!profile.virtual ? "virtual" : "physical"
            } location`}
          >
            {!!profile.virtual ? "language" : "house"}
          </span>
          <span
            className="badgeSpan"
            data-pr-tooltip="This status indicates whether a partner has confirmed their account information as correct"
          >
            <Badge
              value={
                profile.entityStatus ? profile.entityStatus : "unconfirmed"
              }
              severity={refEntityStatus}
              tooltip="ToolTip"
            />
          </span>
        </div>
        <div className={styles.locationCardNameButtons}>
          <Button
            label="Select"
            type="button"
            tooltip="Select the referral partner"
            className={`${styles.button} ${styles.searchSidebarButton}`}
            onClick={() => {
              const entity = { ...profile, select: true }
              onSelectProfile(entity)
            }}
          />
          <Button
            label="Services"
            type="button"
            tooltip="Show all services provided"
            onClick={() => {
              setServiceDialogServices(
                Array.from(new Set(profile.referralCategories)).map(
                  (category) => {
                    return { value: category }
                  }
                )
              )
              setServiceDialogTitle(`Services offered by ${profile.entityName}`)
            }}
            className={`${styles.button} ${styles.searchSidebarButton}`}
          />
          {!!profile.website ? (
            <Button
              type="button"
              onClick={() => {
                let url = profile.website

                if (!!url) {
                  if (!url.includes("http")) {
                    url = `https://${url}`
                  }

                  window.open(url, "_blank", "noopener noreferrer")
                }
              }}
              className={`${styles.button} ${styles.browseButton} `}
              tooltip={"Browse to website"}
            >
              <span className="material-icons">{"language"}</span>
            </Button>
          ) : null}
        </div>
      </div>
    )
  }

  return (
    <>
      <Dialog
        header={serviceDialogTitle}
        onHide={() => setServiceDialogTitle("")}
        visible={serviceDialogTitle !== ""}
        baseZIndex={1000}
      >
        <div style={{ minHeight: "300" }}>
          <ListBox filter options={serviceDialogServices} optionLabel="value" />
        </div>
      </Dialog>
      <Dialog
        header={"Partner profile found"}
        visible={showDialog}
        onHide={() => {
          onHideDialog()
        }}
        style={{ width: "600px", maxHeight: "900px" }}
      >
        <div className={styles.container}>
          <div className={styles.gridItemHeader}>
            Profile validation found matching partners, please select the
            correct partner location from the list, or click cancel to return to
            the profile form.
          </div>
          <div className={styles.gridItemBody}>
            {validationPartnerProfile?.locations?.map((location, index) => (
              <div key={index}>
                <PartnerLocation profile={location} />
              </div>
            ))}
          </div>
          <div className={styles.gridItemButton}>
            <Button
              label="Cancel"
              icon="pi pi-times"
              type="button"
              className={styles.button}
              onClick={() => {
                onHideDialog()
              }}
            />
          </div>
        </div>
      </Dialog>
    </>
  )
}
